import style from './Footer.module.scss'

export default function Footer() {
    return <footer className={style.footer}>
        <p className={style.footerText}>
            ©2022 by Avenus
        </p>
    </footer>
}
